<!-- 赛况管理 -->
<template>
    <div>
    <event-head></event-head>
        <div style="margin-top: 20px;">
            <span style="color: #fff;">选择日期:</span>
            <el-date-picker v-model="pageInfo.day" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                style="margin-left: 20px;" @change="changeDate">
            </el-date-picker>
        </div>
        <div class="teamContent">
            <el-table :data="courseData" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60">
                </el-table-column>
                <el-table-column prop="round" label="轮次名称" align="center"></el-table-column>
                <!-- <el-table-column prop="matchDate" label="日期" align="center"></el-table-column> -->
                <el-table-column prop="matchTimeInfo" label="时间" align="center"></el-table-column>
                <el-table-column prop="formatType" label="赛程类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.formatType == 1">小组赛</span>
                        <span v-if="scope.row.formatType == 2">淘汰赛</span>
                        <span v-if="scope.row.formatType == 0">--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="homeTeamName" label="主队" align="center"></el-table-column>
                <el-table-column prop="homeTeamShirt" label="主队球衣" align="center"></el-table-column>
                <el-table-column prop="awayTeamName" label="客队" align="center"></el-table-column>
                <el-table-column prop="awayTeamShirt" label="客队球衣" align="center"></el-table-column>
                <el-table-column prop="status" label="场次状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">待开始</span>
                        <span v-if="scope.row.status == 2">进行中</span>
                        <span v-if="scope.row.status == 3" style="color:#b3b3b3">已结束</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="matchCourse(scope.row)">查看赛况</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>
<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {EventHead},
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 12,
                count: 0,
                day: ''
            },
            matchInfo: {},
            courseData: [],
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getMatchScheduleList();
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 头部组件切换比赛，加载接口数据
        // changeMatch(match) {
        //     this.matchInfo = match;
        //     this.getMatchScheduleList();
        // },
        // 获取赛程
        async getMatchScheduleList() {
            const params = {
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                day: this.pageInfo.day
            };
            const { res } = await this.$http.get(`/Match/MatchScheduleList/${this.matchInfo.matchId}`, { params });
            this.courseData = res.data.list || [];
            this.pageInfo.count = res.data.total;
            this.courseData.map(item => {
                item.matchTimeInfo = item.matchDate==null?item.matchDate:item.matchDate.slice(0, 10) + item.matchTime==null?item.matchTime:item.matchTime.slice(10, 20)
            })
        },
        // 选择日期
        changeDate() {
            this.getMatchScheduleList()
        },
        // 分页
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.getMatchScheduleList();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            console.log(1111, val)
            this.getMatchScheduleList();
        },
        matchCourse(row) {
            this.$router.push({
                name: 'outLists',
                query: {
                    matchId: this.matchInfo.matchId,
                    matchScheduleId: row.matchScheduleId,
                    homeTeamName: row.homeTeamName,
                    homeTeamId: row.homeTeamId,
                    awayTeamName: row.awayTeamName,
                    awayTeamId: row.awayTeamId,
                    status:row.status
                },
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.league-match {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: linear-gradient(#7ECB2B, #4ebbd6);
    padding: 20px;
    border-radius: 20px;

    .leagueImage {
        width: 65px;
        height: 65px;
    }

    .leagueInfo {
        display: flex;
        align-items: center;
    }

    .teamInfo {
        display: flex;
        flex-direction: column;
        margin-left: 15px;
    }

    .lengueName {
        font-size: 23px;
    }

    .application {
        margin-top: 10px;
        font-size: 13px;
        display: flex;
        align-items: center;
    }

    .teamNum {
        color: #2e10db;
    }

    .feeType {
        margin-left: 20px;
        color: rgb(224, 205, 120);
    }

}

.teamContent {
    margin-top: 30px;

    .teamCard {
        margin-top: 15px;

        .date {
            font-size: 19px;
            font-weight: bold;
        }

        .time {
            display: flex;
            justify-content: center;
            color: #d1b518;
            margin-top: 10px;
            height: 20px;
        }

        .team {
            width: 120px;
            display: flex;
            justify-content: center;
        }

        .matchInfo {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
        }

        .el-image {
            width: 50px;
            height: 50px;
        }

        .round {
            display: flex;
            justify-content: center;
            margin-top: 10px;
        }
    }

}
/deep/.el-input--small .el-input__inner {
    color: #e9e9e9;
  }
</style>